<section fxLayout="column" fxLayoutAlign="center center">
  <div class="loader">
    <span>
      Carregando
    </span>
  </div>
</section>
